import { render, staticRenderFns } from "./financialConfirmation.vue?vue&type=template&id=65511056&scoped=true"
import script from "./financialConfirmation.vue?vue&type=script&lang=js"
export * from "./financialConfirmation.vue?vue&type=script&lang=js"
import style0 from "./financialConfirmation.vue?vue&type=style&index=0&id=65511056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65511056",
  null
  
)

export default component.exports